import type { ReactNode } from "react";

import classNames from "classnames";
import React from "react";
import { NavLink } from "react-router-dom";

interface IMenuNavLinkProps {
  to: string;
  children: ReactNode;
  disabled?: boolean;
  id?: string;
  onClick?: (e: React.MouseEvent<HTMLAnchorElement>) => void;
}

const MenuNavLink = ({
  to,
  children,
  disabled,
  id,
  onClick,
}: IMenuNavLinkProps) => {
  if (disabled) {
    return <div className="nav-link opacity-25">{children}</div>;
  }

  return (
    <NavLink
      id={id}
      to={to}
      onClick={onClick}
      className={({ isActive }) =>
        classNames("nav-link", {
          "bg-success-bg text-success rounded-2 border-start border-success border-2":
            isActive,
        })
      }
    >
      {children}
    </NavLink>
  );
};

export default MenuNavLink;
